<div class="grid grid-cols-1 md:grid-cols-3 gap-8 p-4">
  @if (showShiftManager()) {
    <p-card [header]="'Shift Manager' | transloco" class="h-full cursor-pointer" routerLink="/service/lite_schedule/">
      <ng-template #header>
        <img alt="Shift Manager" src="/shift-manager.png" class="w-full h-64 object-contain bg-white rounded-t-2xl p-4" />
      </ng-template>
      <p class="m-0 text-surface-600 dark:text-surface-400">
        {{ 'Shift Manager Description' | transloco }}
      </p>
    </p-card>
  }

  @if (showStaffManager()) {
    <p-card [header]="'Staff Manager' | transloco" class="h-full cursor-pointer" routerLink="/hr/employees">
      <ng-template #header>
        <img alt="Staff Manager" src="/staff-manager.png" class="w-full h-64 object-contain bg-white rounded-t-2xl p-4" />
      </ng-template>
      <p class="m-0 text-surface-600 dark:text-surface-400">
        {{ 'Staff Manager Description' | transloco }}
      </p>
    </p-card>
  }

  @if (showTaskManager()) {
    <p-card [header]="'Task Manager' | transloco" class="h-full cursor-pointer" routerLink="/service/tasks/">
      <ng-template #header>
        <img alt="Task Manager" src="/task-manager.png" class="w-full h-64 object-contain bg-white rounded-t-2xl p-4" />
      </ng-template>
      <p class="m-0 text-surface-600 dark:text-surface-400">
        {{ 'Task Manager Description' | transloco }}
      </p>
    </p-card>
  }
</div>
